<div class="credit-card-modal" id="credit-card-modal">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-align-center"
      id="modal-label"
    >
      <i class="fal fa-credit-card"></i> ADD NEW CREDIT CARD
    </h1>
    <button
      type="button"
      (click)="onHideDialog()"
      class="btn btn-icon close"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>

  <div class="modal-body">
    @if (fetchingCountries) {
      <app-infinite-progress [inProgress]="true"></app-infinite-progress>
    }

    @if (!fetchingCountries) {
      <form
        class="row px-3"
        [formGroup]="cardForm"
        (ngSubmit)="onSaveCreditCard($event)"
      >
        <div class="col-12">
          <div
            class="input-group full-width mb-0"
            [ngClass]="validationClassName(label)"
          >
            <label for="cardName"
              >Name of Card
              <span class="lowercase"
                >(Name Your Entry On Perch For Future Use)</span
              >
              &nbsp;
              @if (
                label.invalid && label.touched && label.getError('required')
              ) {
                <span class="text-danger font-6">Name is required</span>
              }
            </label>
            <input
              [formControl]="label"
              type="text"
              name="cardName"
              id="cardName"
              minlength="1"
              maxlength="255"
              placeholder="My Corporate Card"
            />
          </div>
        </div>
        <div class="col-12 my-2">
          Please input your credit card information below. You will be charged
          when your item(s) are shipped. This may result in multiple charges
          appearing on your card.<br />
          Note: We accept VISA, Mastercard, and AMEX as payment.
        </div>
        <div class="col-sm-12 col-md-6">
          <div
            class="input-group full-width"
            [ngClass]="validationClassName(cardholderName)"
          >
            <label for="cardholder-name"
              >Cardholder Name &nbsp;
              @if (
                cardholderName.invalid &&
                cardholderName.touched &&
                cardholderName.getError('required')
              ) {
                <span class="text-danger font-6"
                  >Cardholder Name is not valid</span
                >
              }
            </label>
            <input
              [formControl]="cardholderName"
              type="text"
              name="cardholderName"
              id="cardholderName"
              minlength="1"
              maxlength="255"
              placeholder="The Name as it Appears on the Card"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div
            class="input-group full-width"
            [ngClass]="validationClassName(ccNumber)"
          >
            <label for="ccNumber"
              >Credit Card Number &nbsp;
              @if (ccNumber.invalid && ccNumber.touched) {
                <span class="text-danger font-6"
                  >Credit Card Number is not valid</span
                >
              }
              <!-- <span
            class="text-danger font-5"
            [ngStyle]="validationLabelStyle(creditCardTypeIsInvalid)"
            >This card type is not accepted. Please use different card.</span
            > -->
            </label>
            <input
              [formControl]="ccNumber"
              type="text"
              name="ccNumber"
              id="ccNumber"
              minlength="14"
              maxlength="23"
              placeholder="**** **** **** ****"
              (input)="onInputCCNumber($event)"
            />
            <!-- min char should be 12 max char should be 19  -->
            <!-- the min/max values set include space char as well -->
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="input-group" [ngClass]="validationClassName(expiresAt)">
            <label for="expiresAt"
              >Expiry Date &nbsp;
              @if (expiresAt.invalid && expiresAt.touched) {
                <span class="text-danger font-6">
                  @if (expiresAt.getError('required')) {
                    Expiry Date is required
                  }
                  @if (expiresAt.getError('pattern')) {
                    Expiry Date is not valid
                  }
                </span>
              }
            </label>
            <input
              [formControl]="expiresAt"
              type="text"
              name="expiresAt"
              id="expiresAt"
              minlength="5"
              maxlength="5"
              placeholder="MM / YY"
              (input)="onInputExpireDate($event)"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="input-group" [ngClass]="validationClassName(cvv)">
            <label for="cvv"
              >Security Code <span class="lowercase">(CVV)</span> &nbsp;
              @if (cvv.invalid && cvv.touched) {
                <span class="text-danger font-6">
                  @if (cvv.getError('required')) {
                    Security Code is required
                  }
                  @if (cvv.getError('pattern')) {
                    Security Code is not valid
                  }
                </span>
              }
            </label>
            <input
              [formControl]="cvv"
              type="text"
              name="cvv"
              id="cvv"
              minlength="3"
              maxlength="4"
              placeholder="****"
              (input)="onInputCVV($event)"
            />
          </div>
        </div>
        <div class="col-12">
          <div
            class="input-group full-width"
            [ngClass]="validationClassName(street)"
          >
            <label for="street"
              >Street Address &nbsp;
              @if (
                street.invalid && street.touched && street.getError('required')
              ) {
                <span class="text-danger font-6"
                  >Street Address is required</span
                >
              }
            </label>
            <input
              [formControl]="street"
              type="text"
              name="street"
              id="street"
              placeholder="Enter Billing Street Address for this Card"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="input-group" [ngClass]="validationClassName(city)">
            <label for="city"
              >City &nbsp;
              @if (city.invalid && city.touched && city.getError('required')) {
                <span class="text-danger font-6">City is required</span>
              }
            </label>
            <input
              [formControl]="city"
              type="text"
              name="city"
              id="city"
              placeholder="Enter Billing City"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="input-group" [ngClass]="validationClassName(state)">
            <label for="state">State / Province / Region</label>
            <input
              [formControl]="state"
              type="text"
              name="state"
              id="state"
              placeholder="Enter Billing State"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="input-group" [ngClass]="validationClassName(postalCode)">
            <label for="postalCode"
              >ZIP / Postal Code &nbsp;
              @if (postalCode.invalid && postalCode.touched) {
                <span class="text-danger font-6">
                  @if (postalCode.getError('required')) {
                    Postal Code is required
                  }
                  @if (postalCode.getError('pattern')) {
                    Postal Code is not valid
                  }
                </span>
              }
            </label>
            <input
              [formControl]="postalCode"
              type="text"
              name="zip"
              id="zip"
              placeholder="Enter Billing Postal Code"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div
            class="input-group"
            [ngClass]="{ 'input-danger': selectedCountry == '' }"
          >
            <label for="country"
              >Country &nbsp;
              @if (
                country.invalid &&
                country.touched &&
                country.getError('required')
              ) {
                <span class="text-danger font-6">Country is required</span>
              }
            </label>
            <ng-select
              class="custom-select__dropdown"
              formControlName="country"
              [items]="countries"
              bindLabel="label"
              bindValue="isoCode"
              placeholder="Choose Billing Country"
              dropdownPosition="top"
              [searchable]="false"
              [clearable]="false"
              (change)="onSelectCountry($event)"
            >
            </ng-select>
          </div>
        </div>
        <div class="col-12 text-center">
          <button
            id="btn-submit-credit-card"
            class="btn btn-primary"
            type="submit"
            [disabled]="isSavingCreditCard"
          >
            @if (isSavingCreditCard) {
              <i class="fal fa-sync rotate me-2"></i>
            }
            Submit
          </button>
        </div>
      </form>
    }
  </div>
</div>
